import { LoadingIcon } from 'bc-front-sagacomponents';
import { ConnectedRouter } from 'connected-react-router';
import { ReactNode, useEffect } from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { Persistor, persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import configureStore from '../../redux/configureStore';
// import rootSaga from "../../sagas";
import { getKeycloakParsed, loginIfRequired } from '../../services/Authentification/authentification';
import history from '../../services/history';

interface Props {
  children: ReactNode;
}

function ReduxProvider(props: Props) {
  let store: Store;
  let persistor: Persistor;

  // Création du store Redux
  const initialState = {};
  store = configureStore(initialState, history);

  // Démarrage de la root saga
  //@ts-ignore
  // store.runSaga(rootSaga);

  persistor = persistStore(store);

  const token = getKeycloakParsed();
  useEffect(() => {
    history.listen(() => {
      const token = getKeycloakParsed();
      if (token) {
        if (token && token.exp && token.exp * 1000 < Date.now()) {
          sessionStorage.clear();
          localStorage.clear();
          loginIfRequired();
        }
      }
    });
  }, [token]);
  return (
    <Provider store={store}>
      <PersistGate loading={<LoadingIcon />} persistor={persistor}>
        <ConnectedRouter history={history}>{props.children}</ConnectedRouter>
      </PersistGate>
    </Provider>
  );
}

export default ReduxProvider;
